import React from 'react'
import { IBadgeProps } from './interfaces'
import { Tooltip } from 'antd'
import { HOLD_OUT_COMPUTED_STATUS, StatusType } from '../../enums/status-type'
import { titleCase } from '../../_utils/utils'
import './status-badge.scss'
import {
    CarryOutOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    FormOutlined,
    WarningOutlined,
    WifiOutlined,
} from '@ant-design/icons'

/*
    "expanded" view forces hidden tooltip
    and displays the status text to the right
    of the badge
 */
interface IProps extends IBadgeProps {
    status: string
    expanded?: boolean
    holdOut: boolean
}

export const NotificationStatusBadge: React.FC<IProps> = (props) => {
    const hideTooltip = props.hideTooltip || props.expanded

    let text = props.status
    let icon = <CarryOutOutlined />

    if (props.holdOut) {
        if (props.status === StatusType.DRAFT.name) {
            text = props.status
            icon = <FormOutlined />
        } else {
            text = HOLD_OUT_COMPUTED_STATUS
            icon = <CarryOutOutlined />
        }
    } else {
        switch (props.status) {
            case StatusType.COMPLETED.name:
                text = 'DELIVERED'
                break
            case StatusType.DELIVERING.name:
            case StatusType.QUEUED.name:
                text = 'DELIVERING'
                icon = <WifiOutlined />
                break
            case StatusType.SCHEDULED.name:
            case StatusType.SCHEDULING.name:
                text = 'SCHEDULED'
                icon = <ClockCircleOutlined />
                break
            case StatusType.CANCELLED.name:
            case StatusType.CANCELLING.name:
                text = 'CANCELLED'
                icon = <CloseCircleOutlined />
                break
            case StatusType.FAILED.name:
                icon = <WarningOutlined />
                break
            case StatusType.DRAFT.name:
                icon = <FormOutlined />
                break
            default:
                break
        }
    }

    const badge = <span className={`status-icon status-${text}`}>{icon}</span>

    return (
        <span className="status-badge notification-status-badge">
            {hideTooltip ? (
                !props.expanded ? (
                    badge
                ) : (
                    <>
                        {badge}
                        <span className="status-name">{titleCase(text)}</span>
                    </>
                )
            ) : (
                <Tooltip title={props.tooltip || text}>{badge}</Tooltip>
            )}
        </span>
    )
}
